if(!customElements.get('pincode-check')){
    class pincodeCheck extends HTMLElement{
        constructor(){
            super();
            this.pincodeLocationBtn = this.querySelector('.pincode-location');
            this.pincodeMsg = this.querySelector('.pincode-msg');
            this.pincodeInput = this.querySelector('.pincode-input');
            this.productId = this.getAttribute('data-product-id');
            this.pincodeCustomerMsgWrapper = this.querySelector('.pincode-customer_msg-wrapper');
            this.pincodeDeliveryDays = this.querySelector('.pincode-delivery-days');
            this.pincodeCod = this.querySelector('.pincode-cod');
            this.pincodeCodAvailable = this.querySelector('.pincode-cod_available');
            this.pincodeCheckBtn = this.querySelector('.pincode-check');
            this.pincode = sessionStorage.getItem('pincode') || null;
        }

        connectedCallback(){
            this.pincodeLocationBtn.addEventListener('click', (evt) => {
                this.getPincode(evt);
            });
            this.pincodeCheckBtn.addEventListener('click', (evt) => {
                this.pincode = this.pincodeInput.value;
                if(/^\d{6}$/.test(this.pincode)){
                    this.getServiceability(evt);
                } else {
                    this.userMessage("Please enter a valid pincode!");
                }
            });
            if(this.pincode){
                this.pincodeInput.value = this.pincode;
                this.getServiceability();
            } else {
                this.pincodeInput.value = '';
            }
        }
        
        async getServiceability(evt){
            if(!this.pincode || !this.productId){
                this.userMessage("Unable to fetch serviceability. Please try again later.");
                return
            };
            if (evt) evt.target.parentElement.classList.add('spinner-loading')
            const url = 'https://snooplaypinuat.marmeto.com/api/multiZoneEdd';
            try {
                let response = await fetch(url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(
                        [
                            {
                                "productId": this.productId,
                                "deliveryDistrictPincode": this.pincode
                            }
                        ]
                    )
                });
                let data = await response.json();
                if (data.data && data.data[0].EstimatedDeliveryDays) {
                    this.pincodeCustomerMsgWrapper.classList.remove('hidden');
                    sessionStorage.setItem('pincode', this.pincode);
                    let productPincodeData = data.data[0].EstimatedDeliveryDays
                    // Calculate the estimated delivery date(s)
                    const currentDate = new Date();
                    let deliveryMessage = '';
                    if (productPincodeData.includes('-')) {
                        // Format "03-04": Calculate both dates
                        const [startDays, endDays] = productPincodeData.split('-').map(Number);
                        const startDate = new Date(currentDate);
                        const endDate = new Date(currentDate);
                        startDate.setDate(currentDate.getDate() + startDays);
                        endDate.setDate(currentDate.getDate() + endDays);

                        const options = { month: 'short', day: 'numeric' };
                        const formattedStartDate = startDate.toLocaleDateString(undefined, options);
                        const formattedEndDate = endDate.toLocaleDateString(undefined, options);
                        deliveryMessage = `${formattedStartDate} - ${formattedEndDate}`;
                    }else if(productPincodeData === 'Today/Tomorrow'){
                        deliveryMessage = 'Today/Tomorrow'
                    }
                    this.pincodeDeliveryDays.innerHTML = deliveryMessage;
                    if (data.data[0].COD) {
                        this.pincodeCod.classList.remove('hidden');
                        this.pincodeCodAvailable.innerHTML = data.data[0].COD;
                      }else{
                        this.pincodeCod.classList.add('hidden');
                      }
                } else {
                    this.userMessage("Not serviceable in your area!");
                    sessionStorage.removeItem('pincode');
                }   
            } catch (error) {
                console.error("Error fetching serviceability data:", error);
                this.userMessage("Error fetching serviceability data.");
            }
            if (evt) evt.target.parentElement.classList.remove('spinner-loading')
        }

        extractPostalCode(components) {
            const comp = components.find(c => c.types.includes("postal_code"));
            return comp ? comp.long_name : null;
        }

        async getPincodeFromCoords(lat,lng,evt){
            if(!lat || !lng){
                this.userMessage("Unable to fetch pincode. Please try again later.");
                return
            };
            const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=AIzaSyBor61Uz7MhfKWKeF-OwNqqSv4i70OSe5U`;
            try {
                let response = await fetch(url);
                let data = await response.json();
                if (data.status === "OK") {
                    const result = data.results[0];
                    this.pincode = this.extractPostalCode(result.address_components);
                    this.pincodeInput.value = this.pincode;
                    this.getServiceability(evt);
                } else {
                    this.userMessage("Unable to fetch pincode. Please try again later.");
                }
            } catch (error) {
                this.userMessage("Error fetching geolocation data.");
            }
        }

        getPincode(evt) {
            const storedLat = sessionStorage.getItem('latitude');
            const storedLng = sessionStorage.getItem('longitude');
            if (storedLat && storedLng) {
              this.getPincodeFromCoords(parseFloat(storedLat), parseFloat(storedLng),evt);
            } else {
              // Fetch coordinates and store them
              navigator.geolocation.getCurrentPosition(
                (position) => {
                  const lat = position.coords.latitude;
                  const lng = position.coords.longitude;
                  // Store in sessionStorage
                  sessionStorage.setItem('latitude', lat);
                  sessionStorage.setItem('longitude', lng);
                  this.getPincodeFromCoords(lat,lng,evt);
                },
                (error) => {
                  console.error(error);
                  this.userMessage("Please enable location permission from settings and try again!");
                }
              );
            }
        }

        userMessage(msg){
            this.pincodeCustomerMsgWrapper.classList.add('hidden');
            this.pincodeMsg.textContent = msg;
            this.pincodeMsg.classList.add('error');
            setTimeout(() => {
                this.pincodeMsg.textContent = ""
                this.pincodeMsg.classList.remove('error');
            }, 3000);
        }
    }
    customElements.define('pincode-check', pincodeCheck);
}   